import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge has to be told about the token scale, or it silently EATS
 * colours: `text-meta` (our 13px size) is not a t-shirt size, so it fell into
 * tailwind-merge's `text-color` group — the same group as `text-ink-2`. Passing
 * both through cn() therefore dropped the ink class and the element fell back to
 * `text-foreground`, which is tuned for a dark surface. That is the real reason
 * the three `[&_span]:text-ink-2` patches were needed in JobApplicationsTab:
 * arbitrary variants are never merged away, so they were papering over this.
 * Declaring the type scale as font-size fixes it everywhere cn() is used.
 * KEEP IN SYNC: any new fontSize token added to tailwind.config.js must be added to the
 * list below, or cn() will start silently stripping ink colours again.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['title', 'section', 'body', 'meta', 'caption'] }],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
